import type { NumericPoint } from "./numeric-series";

/** Return the first index whose x-value is greater than or equal to `target`. */
export function lowerBound<Y>(
  points: readonly NumericPoint<Y>[],
  target: number,
): number {
  let lo = 0;
  let hi = points.length;

  while (lo < hi) {
    const mid = (lo + hi) >>> 1;
    if (points[mid][0] < target) lo = mid + 1;
    else hi = mid;
  }

  return lo;
}

/** Return points whose x-values fall within `[start, end)`. */
export function pointsInRange<Y>(
  points: readonly NumericPoint<Y>[],
  start: number,
  end: number,
): NumericPoint<Y>[] {
  const startIndex = lowerBound(points, start);
  const result: NumericPoint<Y>[] = [];

  for (let i = startIndex; i < points.length; i++) {
    if (points[i][0] >= end) break;
    result.push(points[i]);
  }

  return result;
}
